<script>
  /** @type {string} */
    export let name;
     /** @type {string} */
    export let src;
     /** @type {string} */
    export let avif;
     /** @type {string} */
    export let webp;
     /** @type {string} */
    export let party;


  $: isThereAHeadshot = (src)=> {
    if (src.includes('person.png')) {
      return false;
    } else {
      return true;
    }
  }

  $: HeadshotExists = isThereAHeadshot(src);
  $: headshotAlt = `Headshot of ${name}`;
  $: noHeadshotAlt = `No photo available for ${name}, generic image`;


</script>

  <picture>
    <source
      type="image/avif"
      srcset={avif}
    />
    <source
      type="image/webp"
      srcset={webp}
    />
    <img 
      src={src} 
      class="{party ? party : ''}"
      alt="{HeadshotExists ? headshotAlt : noHeadshotAlt}"
      width="300" 
      height="300"
    />
  </picture>